import { render, staticRenderFns } from "./Operatori.vue?vue&type=template&id=5c64a4e3&"
import script from "./Operatori.vue?vue&type=script&lang=ts&"
export * from "./Operatori.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports